import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full xl:w-[332px] bg-white text-brown flex flex-col z-[100]" }
const _hoisted_2 = { class: "flex xl:flex-col xl:h-screen" }
const _hoisted_3 = { class: "w-full overflow-y-auto no-scrollbar z-[2000]" }
const _hoisted_4 = { class: "h-14 xl:h-[116px] border-b border-l xl:border-l-0 w-full xl:border-divider pl-2 xl:pl-0 flex justify-between" }
const _hoisted_5 = { class: "w-auto md:w-full h-14 xl:h-24 mb-2" }
const _hoisted_6 = { class: "hidden xl:contents" }
const _hoisted_7 = { class: "pl-2 overflow-y-auto" }

import MenuIcon from "@/components/icons/MenuIcon.vue";
import { computed } from "vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import BlogButton from "@/components/buttons/BlogButton.vue";
import LogoComponent from "@/components/LogoComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenu',
  props: {
    showBlogBtn: { type: Boolean },
    isMenuOpen: { type: Boolean }
  },
  emits: ["toggleMenu"],
  setup(__props: any) {

const props = __props;



const menuIcon = computed(() => {
  if (props.isMenuOpen) {
    return CloseIcon;
  }

  return MenuIcon;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "relative xl:hidden w-14 flex items-center justify-center cursor-pointer bg-active",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleMenu')))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(menuIcon.value))),
        (props.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex flex-col absolute left-0 bottom-0 translate-y-full w-screen md:w-[393px] h-[calc(100vh-100%-64px)] bg-white px-4 z-[2000]",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createVNode(LanguageSwitcher, { class: "w-full flex" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(LogoComponent)
        ]),
        (props.showBlogBtn)
          ? (_openBlock(), _createBlock(BlogButton, {
              key: 0,
              class: "xl:hidden"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createVNode(LanguageSwitcher, { class: "hidden xl:block mt-auto" })
    ])
  ]))
}
}

})